define.alias("shared/components/shared/social/facebook-modal/facebook-page", "settings/components/shared/social/facebook-modal/facebook-page");